const BASE_URL = 'https://www.xpendmarketing.com';

export interface PageSEO {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
}

export const SEO_CONFIG: Record<string, PageSEO> = {
  '/': {
    title: 'Xpend Marketing - The Future of Marketing Intelligence',
    description:
      'Harness the power of advanced analytics and AI to drive unparalleled growth. 500+ successful campaigns, 98% client satisfaction, 150+ industries served.',
    canonical: `${BASE_URL}/`,
    ogImage: `${BASE_URL}/logo-dark.png`,
  },
  '/marketing': {
    title: 'Xpend Marketing - The Future of Marketing Intelligence',
    description:
      'Harness the power of advanced analytics and AI to drive unparalleled growth. 500+ successful campaigns, 98% client satisfaction, 150+ industries served.',
    canonical: `${BASE_URL}/`,
    ogImage: `${BASE_URL}/logo-dark.png`,
  },
  '/careers': {
    title: 'Careers - Xpend Marketing',
    description:
      'Join Xpend Marketing in Tel Aviv. Open positions in engineering, marketing, and analytics. Help shape the future of data-driven marketing intelligence.',
    canonical: `${BASE_URL}/careers`,
    ogImage: `${BASE_URL}/logo-dark.png`,
  },
  '/termsofservice': {
    title: 'Terms of Service - Xpend Marketing',
    description:
      'Read the terms of service for Xpend Marketing website operated by Xpend Global Marketing Ltd.',
    canonical: `${BASE_URL}/termsofservice`,
  },
  '/privacypolicy': {
    title: 'Privacy Policy - Xpend Marketing',
    description:
      'Learn how Xpend Marketing collects, uses, and protects your personal information. Read our full privacy policy.',
    canonical: `${BASE_URL}/privacypolicy`,
  },
  '/accessibilitystatement': {
    title: 'Accessibility Statement - Xpend Marketing',
    description:
      'Xpend Marketing is committed to digital accessibility. Our website conforms to WCAG 2.2 Level AA standards.',
    canonical: `${BASE_URL}/accessibilitystatement`,
  },
};

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Xpend Marketing',
  alternateName: 'Xpend Global Marketing Ltd.',
  url: BASE_URL,
  logo: `${BASE_URL}/logo-dark.png`,
  description: 'AI-powered marketing intelligence platform',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Tel Aviv',
    addressCountry: 'IL',
  },
  sameAs: ['https://www.linkedin.com/company/xpend-global-marketing'],
};
